import { Button } from '@/components/ui/button';
import { Plus, ClipboardList, ChevronLeft, ChevronRight, CalendarDays } from 'lucide-react';
import { format, startOfWeek, addWeeks, subWeeks, subDays, isThisWeek } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface BacklogHeaderProps {
  onCreateClick: () => void;
  currentWeek: Date;
  onWeekChange: (date: Date) => void;
}

export function BacklogHeader({ onCreateClick, currentWeek, onWeekChange }: BacklogHeaderProps) {
  const weekStart = startOfWeek(currentWeek, { weekStartsOn: 1 });
  const weekEnd = subDays(addWeeks(weekStart, 1), 1);
  const isCurrentWeek = isThisWeek(currentWeek, { weekStartsOn: 1 });

  return (
    <div className="flex items-center justify-between gap-4">
      {/* Title */}
      <div className="flex items-center gap-3">
        <div className="p-2 bg-primary/10 rounded-lg">
          <ClipboardList className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-bold tracking-tight">IT Backlog</h1>
          <p className="text-sm text-muted-foreground">
            Gerencie e organize suas tarefas semanais
          </p>
        </div>
      </div>

      {/* Week Navigation */}
      <div className="flex items-center gap-1">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => onWeekChange(subWeeks(currentWeek, 1))}
          className="gap-1"
        >
          <ChevronLeft className="h-4 w-4" />
          Anterior
        </Button>
        
        <div className="flex items-center gap-2 px-3 py-1.5 bg-muted/50 rounded-md min-w-[180px] justify-center">
          <CalendarDays className="h-4 w-4 text-muted-foreground" />
          <span className="font-medium text-sm">
            {format(weekStart, "dd/MM", { locale: ptBR })} - {format(weekEnd, "dd/MM/yyyy", { locale: ptBR })}
          </span>
        </div>
        
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => onWeekChange(addWeeks(currentWeek, 1))}
          className="gap-1"
        >
          Próxima
          <ChevronRight className="h-4 w-4" />
        </Button>
        
        {!isCurrentWeek && (
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => onWeekChange(new Date())}
            className="ml-1"
          >
            Hoje
          </Button>
        )}
      </div>
      
      {/* Create Button */}
      <Button onClick={onCreateClick} className="gap-2">
        <Plus className="h-4 w-4" />
        Nova Tarefa
      </Button>
    </div>
  );
}
